import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CreNgConfig } from 'cre-ng';
import { Subscription } from 'rxjs';

import { WindowService } from '@app/core/window.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-navbar',
  styleUrls: ['./navbar.component.css'],
  templateUrl: './navbar.component.html',
})
export class NavbarComponent implements OnDestroy, OnInit {
  canSearch = false;
  isNotFromPSE = true;

  private loginSub: Subscription;

  constructor(
    private authService: AuthService,
    private creNgConfig: CreNgConfig,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(WindowService) private windowService: Window
  ) {
    this.loginSub = this.authService.login$.subscribe(() => {
      this.canSearch = this.authService.isViewable;
      this.isNotFromPSE = true;
    });
  }

  ngOnInit(): void {
    this.checkQueryParameter();
  }

  checkQueryParameter(): void {
    const sourceParam = this.route.snapshot.queryParams.source;
    if (sourceParam && sourceParam.trim().toUpperCase() === 'PSE') {
      this.isNotFromPSE = false;
      // Additional logic based on 'Source' parameter can go here
    } else {
      this.isNotFromPSE = true;
    }
  }

  goToEtools() {
    this.windowService.location.href = `${this.creNgConfig.serviceApiDomain}/etools`;
  }

  logout() {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this.loginSub.unsubscribe();
  }

  search() {
    const url = new URL(this.windowService.location.href);
    void this.router.navigateByUrl('search' + url.search).then(() => {
      this.windowService.location.reload();
    });
  }
}
